import React, { useState } from 'react';

import AccountCampaignMenubar from '../components/account-campaign-menubar';
import { useGetCampaignsQuery } from '../endpoints/accounts.endpoints';
import { useGetCompaniesQuery } from 'src/pages/billing/endpoints/billing.endpoints';
import CampaignTable from '../components/campaign-table';

const ManageCampaignsTab: React.FC = () => {
  const [searchParams] = useState(() => new URLSearchParams(window.location.search));
  const defaultSearch = searchParams.get('search') || '';

  const [filter, setFilter] = useState<'attention_needed' | 'all'>('attention_needed');
  const [searchQuery, setSearchQuery] = useState(defaultSearch);
  const { data: campaigns = [], isLoading, error, refetch } = useGetCampaignsQuery({});
  const { data: companies = [] } = useGetCompaniesQuery();

  const handleCompanySelect = (campaignId: string, companyId: string) => {
    refetch();
  };

  const handleDoNotBillToggle = (campaignId: string, doNotBill: boolean) => {
    refetch();
  };

  const handlePreBilledToggle = (campaignId: string, preBilled: boolean) => {
    refetch();
  };

  const handleSkuSelect = (campaignId: string, skuId: string) => {
    refetch();
  };

  const handleUserSelect = (campaignId: string, userId: string) => {
    refetch();
  };

  return (
    <div className="h-full w-full flex flex-col space-y-4 pt-0 overflow-hidden">
      <div className="flex">
        <AccountCampaignMenubar
          label='Campaigns'
          items={campaigns}
          className='bg-gray-201 text-black rounded-full'
          selectedFilter={filter}
          filterSelect={setFilter}
          searchQuery={searchQuery}
          searchChange={setSearchQuery}
        />
      </div>
      {/* <AccountTable className='bg-white border-none rounded-lg shadow-md' /> */}
      <div className="flex h-full">
        <CampaignTable
          campaigns={campaigns}
          companies={companies}
          onCompanySelect={handleCompanySelect}
          onDoNotBillToggle={handleDoNotBillToggle}
          onPreBilledToggle={handlePreBilledToggle}
          onSkuSelect={handleSkuSelect}
          onUserSelect={handleUserSelect}
          className='h-full'
          filter={filter}
          searchQuery={searchQuery}
        />
      </div>
    </div>
  );
};

export default ManageCampaignsTab;
